<template>
    <section class="instructions">
        <div class="container">
            <c-instructions-video></c-instructions-video>
        </div>
    </section>
</template>

<script>
    import CInstructionsVideo from "@/components/c-instructions-video";

    export default
    {
        name: 'v-instructions-video',
        components: {
            CInstructionsVideo
        }
    }
</script>